var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ui-chip',{attrs:{"tone":_vm.tone,"dot":!_vm.user.suspended,"icon":_vm.user.suspended ? 'mdi-cancel' : '',"title":_vm.user.suspended ? _vm.user.reason : null}},[_vm._v(_vm._s(_vm.statusText(_vm.user)))])
}
var staticRenderFns = []

export { render, staticRenderFns }